import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";

const Settings = () => {
  const navigate = useNavigate();

  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("darkMode") === "true"
  );

  const [loading, setLoading] = useState(true);
  const [setting, setSetting] = useState(null);
  const [error, setError] = useState(null);

  // ===============================
  // LOAD SETTINGS FROM BACKEND
  // ===============================
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get("/client/setting");


        console.log("SETTING RESPONSE:", res.data);

        // ?? Accept setting even if status flag is weird
        if (res?.data?.setting) {
          setSetting(res.data.setting);
        } else {
          setSetting(null);
        }
      } catch (err) {
        console.error("Failed to load settings:", err);
        setError("Unable to load settings.");
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  // ===============================
  // DARK MODE
  // ===============================
  useEffect(() => {
    document.body.classList.toggle("dark", darkMode);
    localStorage.setItem("darkMode", darkMode);
  }, [darkMode]);

  // ===============================
  // LOGOUT
  // ===============================
  const logout = () => {
    const confirmLogout = window.confirm(
      "Are you sure you want to logout?"
    );
    if (!confirmLogout) return;

    sessionStorage.clear();
    localStorage.clear();
    navigate("/login");
  };

  // ===============================
  // RENDER STATES
  // ===============================
  if (loading) return <p style={{ textAlign: "center" }}>Loading...</p>;

  if (error)
    return <p style={{ textAlign: "center", color: "red" }}>{error}</p>;

  if (!setting)
    return <p style={{ textAlign: "center" }}>No Setting Found</p>;

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>App Settings</h2>

      {/* UI Preference */}
      <SettingItem
        label="Dark Mode"
        value={darkMode}
        onChange={() => setDarkMode(!darkMode)}
      />

      <hr style={styles.divider} />

      {/* Monetization Section */}
      <SettingDisplay
        label="Monetization Enabled"
        value={setting.isMonetization ? "Yes" : "No"}
      />

      <SettingDisplay
        label="Earning Per Hour"
        value={`${setting.earningPerHour ?? 0} ${
          setting.currency?.symbol || ""
        }`}
      />

      <SettingDisplay
        label="Minimum Watch Time (Hours)"
        value={setting.minWatchTime ?? 0}
      />

      <SettingDisplay
        label="Minimum Subscribers"
        value={setting.minSubScriber ?? 0}
      />

      <SettingDisplay
        label="Max Ads Per Day"
        value={setting.maxAdPerDay ?? 0}
      />

      <SettingDisplay
        label="Referral Reward Coins"
        value={setting.referralRewardCoins ?? 0}
      />

      <hr style={styles.divider} />

      <button style={styles.logoutBtn} onClick={logout}>
        Logout
      </button>
    </div>
  );
};

// ===============================
// COMPONENTS
// ===============================
const SettingItem = ({ label, value, onChange }) => (
  <div style={styles.item}>
    <span>{label}</span>
    <input type="checkbox" checked={value} onChange={onChange} />
  </div>
);

const SettingDisplay = ({ label, value }) => (
  <div style={styles.item}>
    <span>{label}</span>
    <strong>{value}</strong>
  </div>
);

// ===============================
// STYLES
// ===============================
const styles = {
  container: {
    maxWidth: 650,
    margin: "30px auto",
    padding: 25,
    borderRadius: 8,
    background: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  },
  heading: {
    marginBottom: 20,
  },
  item: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
    fontSize: 15,
  },
  divider: {
    margin: "25px 0",
  },
  logoutBtn: {
    background: "#e53935",
    color: "#fff",
    padding: "10px 18px",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    fontSize: 15,
  },
};

export default Settings;
